module.exports = "https://static.wmbcdn.com/uniweb/images/432bef04dcf23113be2f13e3bce2f291.svg";